import { render } from "./constrasurvey.vue?vue&type=template&id=be2b1d1a&scoped=true"
import script from "./constrasurvey.vue?vue&type=script&lang=js"
export * from "./constrasurvey.vue?vue&type=script&lang=js"

import "./constrasurvey.vue?vue&type=style&index=0&id=be2b1d1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2b1d1a"]])

export default __exports__